if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              this.error = false;
              this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.form = document.querySelector(".pdp-product-form");
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(evt) {
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia(evt);
    this.updatePrint(evt);
  }

  updatePrint(data){
    var options = data.dataset.options;
    var $op = $('.option-container');
    $('.print-url').html('<a href="'+$(location).attr('href')+'">'+$(location).attr('href')+'</a>');
    if(data.dataset.variant && data.dataset.variant.sku){
      $('.print-sku').html(data.dataset.variant.sku);
    }
    $('.product-options').html('Product Options Selected:');
    $.each(options, function(i,el){
      if(el.value){
        if(i == 0){
          $op.html('<div><div class="label"><strong>'+el.name+'</strong></div><ul><li><span>'+el.value+'</span></li></ul></div>');
        } else {
          $op.append('<div><div class="label"><strong>'+el.name+'</strong></div><ul><li><span>'+el.value+'</span></li></ul></div>');
        }
      }
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia(evt) {
    let imageSrc = '';
    const mainSlider = document.querySelector('.hc-main-slider');
    if (!this.currentVariant) {
      let nextSibling = evt.target.nextElementSibling;
      imageSrc = nextSibling.getAttribute('data-image');
    }
    else {
      if (this.currentVariant.featured_media) {
        const variantImage = this.currentVariant.featured_image.src;
        const parts = variantImage.split('.');
        const extension = parts.pop(); 
        imageSrc = parts.join('.') + '_580x.' + extension;
      };
    }
    if(imageSrc != '') {
      let template = `<div class="product-single__media" data-image="${imageSrc}">
            <img src="${imageSrc}" alt="">
          </div>
        `;
      mainSlider.querySelector('.hc-main-wrap:first-child').innerHTML = template;
      // Update the main image in the print sepcs section
      $('.print-main-img').find('img').attr('src', imageSrc);
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

